<template>
  <div class="space-y-6">
    <div class="flex items-start gap-4">
      <!-- <div
        class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[var(--p-primary-color)] text-sm font-semibold text-white"
      >
        2
      </div> -->

      <div class="min-w-0 flex-1 space-y-4">
        <div class="grid gap-6 md:grid-cols-[2fr_1fr] xl:items-start">
          <div class="space-y-2">
            <div
              class="app-card-glass min-w-0 space-y-4 rounded-lg p-3 shadow-sm sm:p-4 "
            >
              <div class="flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-between">
                <!-- Lado izquierdo -->
                <div class="flex min-w-0 items-center gap-2">
                  <IconMessage width="25" height="25" class="text-[var(--p-primary-color)]  dark:text-[var(--p-surface-0)]" />

                  <label class="montserrat truncate text-md font-semibold text-[var(--p-primary-color)]  dark:text-[var(--p-surface-0)]">
                    {{ templatesTitle }}
                  </label>
                </div>

                <!-- Lado derecho -->
                <AppSelect
                  v-model="selectedCategory"
                  :options="templateCategoryOptions"
                  option-label="name"
                  option-value="value"
                  :show-clear="false"
                  class="w-full sm:w-1/3"
                  :editable="false"
                />
              </div>

              <AppInput
                v-model="searchTerm"
                :placeholder="$t('whatsapp.actions.search_by_name_or_content')"
                class="mb-4"
              >
                <template #icon>
                  <Search :size="15" class="text-(--p-primary-color) dark:text-white" />
                </template>
              </AppInput>
              <div
                v-if="isLoadingTemplates"
                class="rounded-xl border border-dashed border-[var(--p-surface-300)] p-6 text-sm text-[var(--p-surface-500)] dark:border-[var(--p-surface-700)] dark:text-[var(--p-surface-400)]"
              >
                {{ $t('whatsapp.loading_templates') }}
              </div>

              <div
                v-else-if="!availableTemplates.length"
                class="flex rounded-xl border border-dashed border-[var(--p-surface-300)] p-6 text-sm text-[var(--p-surface-500)] dark:border-[var(--p-surface-700)] justify-center dark:text-[var(--p-surface-400)]"
              >
                {{ $t('whatsapp.no_templates') }}
              </div>

              <div
                v-else
                class="grid max-h-[45dvh] gap-3 overflow-y-auto px-1 pb-2 pr-2 scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-[var(--p-surface-300)] dark:scrollbar-thumb-[var(--p-surface-700)] sm:max-h-80"
              >
                <button
                  v-for="template in paginatedTemplates"
                  :key="template.id"
                  type="button"
                  class="cursor-pointer rounded-2xl p-3 text-left shadow-sm transition-all duration-200 sm:p-4"
                  :class="getTemplateCardClass(template)"
                  @click="selectTemplate(template)"
                >
                  <div class="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between sm:gap-3">
                    <div class="min-w-0 flex-1">
                      <p
                        class="truncate text-xs font-medium text-[var(--p-primary-color)] dark:text-[var(--p-surface-0)]"
                      >
                        {{ getTemplateDisplayName(template.content.name) }}
                      </p>
                    </div>

                    <div class="flex flex-wrap gap-1">
                      <span
                        class="rounded-full px-2.5 py-1 text-[11px] font-semibold"
                        :class="getCategoryBadgeClass(template)"
                      >
                        {{ getTemplateCategoryLabel(template) }}
                      </span>

                      <span
                        v-tooltip.top="$t('whatsapp.template_language_tooltip')"
                        class="rounded-full px-2.5 py-1 text-[11px] font-semibold"
                        :class="getCategoryBadgeClass(template)"
                      >
                        {{ template.content.language }}
                      </span>
                    </div>
                  </div>

                  <p
                    class="mt-3 line-clamp-3 text-[12px] leading-5 text-[var(--p-surface-700)] dark:text-[var(--p-surface-0)]/90"
                  >
                    {{ getTemplatePreview(template) }}
                  </p>
                </button>
              </div>

              <div v-if="templatesTotalPages > 1" class="flex items-center justify-center gap-2 sm:justify-end">
                <button
                  type="button"
                  class="flex items-center justify-center cursor-pointer rounded-md p-1 text-[var(--p-primary-color)] transition-colors disabled:cursor-not-allowed disabled:opacity-30 dark:text-[var(--p-text-color)]"
                  :disabled="!canGoPreviousTemplatesPage"
                  @click="requestTemplatesPage(templatesPage - 1)"
                >
                  <ChevronLeft :size="16" />
                </button>

                <span class="text-xs text-[var(--p-surface-500)] dark:text-[var(--p-surface-0)]">
                  {{ templatesPage }}/{{ templatesTotalPages }}
                </span>

                <button
                  type="button"
                  class="flex items-center justify-center cursor-pointer rounded-md p-1 text-[var(--p-primary-color)] transition-colors disabled:cursor-not-allowed disabled:opacity-30 dark:text-[var(--p-text-color)]"
                  :disabled="!canGoNextTemplatesPage"
                  @click="requestTemplatesPage(templatesPage + 1)"
                >
                  <ChevronRight :size="16" />
                </button>
              </div>

              <div
                v-if="selectedTemplate && templateParameters.length > 0"
                class="space-y-3 border-t border-[var(--p-surface-200)]"
              >
                <label
                  class="montserrat font-medium block text-sm mt-2 text-[var(--p-primary-color)] dark:text-[var(--p-text-color)]"
                >
                  {{ $t('whatsapp.template_parameters') }}
                </label>

                <div class="grid gap-3 sm:grid-cols-2">
                  <div
                    v-for="param in templateParameters"
                    :key="`${param.componentType}-${param.componentIndex}-${param.parameterIndex}`"
                    class="space-y-1"
                  >
                    <label
                      class="block text-xs font-medium text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]"
                    >
                      {{ param.label }}
                    </label>
                    <AppSelect
                      v-if="useCustomFieldParameters"
                      v-model="param.value"
                      :options="customFieldParameterOptions"
                      option-label="name"
                      option-value="value"
                      :placeholder="$t('whatsapp.select_custom_field')"
                      :show-clear="false"
                      :editable="false"
                      :disabled="!customFieldParameterOptions.length"
                      class="w-full"
                      size="small"
                      @update:modelValue="updatePreview"
                    />
                    <AppInput
                      v-else
                      v-model="param.value"
                      :placeholder="param.placeholder"
                      class="w-full"
                      size="small"
                      @update:modelValue="updatePreview"
                    />
                  </div>
                </div>
              </div>
            </div>
            <label
              v-if="!selectedTemplate"
              severity="info"
              :closable="false"
              size="small"
              class="text-xs"
            >
              {{ $t('whatsapp.select_template_to_continue') }}
            </label>

            <label
              v-else-if="templateParameters.length > 0 && !allParametersFilled"
              severity="warn"
              :closable="false"
              size="small"
              class="text-xs"
            >
              {{ $t('whatsapp.complete_template_parameters') }}
            </label>
          </div>
          <div class="flex justify-center md:justify-start">
            <PreviewPhoneTemplate
              :body="selectedTemplate?.content.body || ''"
              :body-examples="previewBodyExamples || []"
              :header="previewHeader"
              :example-header="previewExampleHeader"
              :footer="selectedTemplate?.content.footer || ''"
              :buttons="previewButtons"
              :carousel="previewCarousel"
              :limited-time-offer="previewLimitedTimeOffer"
              :is-carousel="isCarouselTemplate"
              :combination="selectedTemplate?.combination || ''"
              :category="selectedTemplate?.content.category || ''"
              :profile-image-component="IconNebula"
              :scale="1.3"
            />

            <!-- <p
              v-if="!selectedTemplate"
              class="mt-3 text-center text-xs text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]"
            >
              {{ $t('whatsapp.preview_select_template_hint') }}
            </p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import AppSelect from '@/components/atoms/selects/AppSelect.vue'
import type {
  Template,
  TemplateSendComponent,
  TemplateSendParameter,
} from '@/components/whatsapp/types/interfaces'
import PreviewPhoneTemplate from '../../chat-view/PreviewPhoneTemplate.vue'
import { FormatHeader } from '@/services/templates/enums/format-header.enum'
import { TypeButton } from '@/services/templates/enums/type-button.enum'
import AppInput from '@/components/atoms/inputs/AppInput.vue'
import IconMessage from '@/assets/svg/message_icon.svg?component'
import IconNebula from '@/assets/svg/icon_nebula.svg?component'
import type {
  IButtonTemplate,
  ICarouselPayloadTemplate,
  ICarouselTemplate,
  IHeaderTemplate,
  ILimitedTimeOfferTemplate,
} from '@/services/templates/interfaces/template.interface'
import { ChevronLeft, ChevronRight, Search } from 'lucide-vue-next'
import type { SelectOption } from '@/components/atoms/selects/types/select-option.types'
import { getTemplateDisplayName } from '@/helpers/template-name.helper'
import type { IPaginationMeta } from '@/services/interfaces/pagination-response.interface'

interface TemplateParam {
  label: string
  placeholder: string
  value: string
  componentType: string
  componentIndex: number | null
  parameterIndex: number
  parameterType: string
}

interface CustomFieldOption {
  id: string
  value?: string | null
  name?: string | null
}

type PreviewButtonSource = NonNullable<Template['content']['buttons']>[number] & {
  example?: string | null
  url?: string | null
  phone_number?: string | null
}

type PreviewContent = Template['content'] & {
  example_header?: string | null
  limited_time_offer?: ILimitedTimeOfferTemplate | null
}

interface Props {
  templates: Template[]
  campaignId?: string | null
  isLoadingTemplates?: boolean
  selectedTemplate?: Template | null
  customFields?: CustomFieldOption[]
  useCustomFieldParameters?: boolean
  templatesMeta?: IPaginationMeta | null
}

const props = withDefaults(defineProps<Props>(), {
  campaignId: null,
  isLoadingTemplates: false,
  selectedTemplate: null,
  customFields: () => [],
  useCustomFieldParameters: false,
  templatesMeta: null,
})

const emit = defineEmits<{
  'update:template': [template: Template | null]
  'update:parameters': [parameters: TemplateSendComponent[] | null]
  'load-templates': [
    params: { search?: string | null; category?: string | null; page: number; size: number },
  ]
}>()

type TemplateCategoryFilter = 'ALL' | 'MARKETING' | 'UTILITY'

const { t } = useI18n()
const selectedCategory = ref<TemplateCategoryFilter>('ALL')

const templateCategoryOptions = computed<SelectOption[]>(() => [
  {
    name: t('whatsapp.filter_all_templates'),
    value: 'ALL',
  },
  {
    name: t('whatsapp.template_type_marketing'),
    value: 'MARKETING',
  },
  // {
  //   name: t('whatsapp.template_type_message'),
  //   value: 'AUTHENTICATION',
  // },
  {
    name: t('whatsapp.template_type_utility'),
    value: 'UTILITY',
  },
])

const searchTerm = ref('')

const selectedTemplate = ref<Template | null>(null)
const templateParameters = ref<TemplateParam[]>([])
const templatesPage = ref(1)
const templatesPageSize = 10 //cantidad de templates en la pagina
let searchDebounceId: ReturnType<typeof setTimeout> | null = null

//variable para mostrar los parametros para archivos
const showHeaderMediaParameters = false

// La categoria tambien la filtra el backend: filtrarla aqui recortaba solo la
// pagina visible mientras el paginador seguia contando las paginas sin filtrar.
const availableTemplates = computed(() =>
  [...props.templates].sort((a, b) =>
    a.content.name.localeCompare(b.content.name, undefined, { sensitivity: 'base' }),
  ),
)

const templatesTotalPages = computed(() => Math.max(1, props.templatesMeta?.pages ?? 1))

const paginatedTemplates = computed(() => availableTemplates.value)

const canGoPreviousTemplatesPage = computed(
  () => templatesPage.value > 1 && !props.isLoadingTemplates,
)

const canGoNextTemplatesPage = computed(
  () => templatesPage.value < templatesTotalPages.value && !props.isLoadingTemplates,
)

const emitLoadTemplates = (page = templatesPage.value) => {
  const nextPage = Math.min(Math.max(page, 1), templatesTotalPages.value)
  templatesPage.value = nextPage
  emit('load-templates', {
    search: searchTerm.value.trim() || null,
    category: selectedCategory.value,
    page: nextPage,
    size: templatesPageSize,
  })
}

const requestTemplatesPage = (page: number) => {
  emitLoadTemplates(page)
}

// `templates` es solo la pagina actual: que el seleccionado no aparezca aqui no
// significa que ya no exista, sino que quedo en otra pagina. Limpiarlo es cosa
// del cambio de campana (mas abajo).
watch(availableTemplates, () => {
  if (templatesPage.value > templatesTotalPages.value) {
    templatesPage.value = templatesTotalPages.value
  }
})

// Al cambiar de campana se limpian busqueda y categoria, y el padre ya recarga
// por su cuenta: sin esta bandera cada limpieza dispararia ademas su propia
// peticion, pidiendo dos veces la misma primera pagina.
let isResettingQuery = false

watch(searchTerm, () => {
  templatesPage.value = 1
  if (searchDebounceId) clearTimeout(searchDebounceId)
  if (isResettingQuery) return
  searchDebounceId = setTimeout(() => emitLoadTemplates(1), 350)
})

watch(selectedCategory, () => {
  templatesPage.value = 1
  if (isResettingQuery) return
  emitLoadTemplates(1)
})

watch(
  () => props.templatesMeta,
  (meta) => {
    templatesPage.value = meta?.page ?? 1
  },
  { immediate: true, deep: true },
)

watch(
  () => props.campaignId,
  async () => {
    isResettingQuery = true
    templatesPage.value = 1
    searchTerm.value = ''
    selectedCategory.value = 'ALL'
    await nextTick()
    isResettingQuery = false

    if (!selectedTemplate.value) return

    selectedTemplate.value = null
    templateParameters.value = []
    emit('update:template', null)
    emit('update:parameters', null)
  },
)

const templatesTitle = computed(() => {
  // El total lo manda el backend, que ya aplica busqueda y categoria.
  const count = props.templatesMeta?.total ?? availableTemplates.value.length

  if (!count) {
    return t('whatsapp.no_templates_available')
  }

  return `${count} ${t('whatsapp.templates_available')}`
})

const allParametersFilled = computed(() => {
  return templateParameters.value.every((param) => param.value.trim() !== '')
})

const useCustomFieldParameters = computed(
  () => props.useCustomFieldParameters && templateParameters.value.length > 0,
)

const customFieldParameterOptions = computed<SelectOption[]>(() => {
  return [...props.customFields]
    .filter((field) => field.id && field.name)
    .sort((a, b) =>
      String(a.name).localeCompare(String(b.name), undefined, { sensitivity: 'base' }),
    )
    .map((field) => ({
      name: field.name || field.id,
      value: field.id,
    }))
})

const getCustomFieldPreviewValue = (fieldId: string) => {
  const customField = props.customFields.find((field) => field.id === fieldId)
  const value = customField?.value?.trim()

  if (value) return value

  const name = customField?.name?.trim()
  return name ? `{{${name}}}` : ''
}

const getParamDisplayValue = (param: TemplateParam) => {
  if (!useCustomFieldParameters.value) return param.value

  return getCustomFieldPreviewValue(param.value)
}

const previewBodyExamples = computed(() => {
  const bodyParams = templateParameters.value.filter((p) => p.componentType === 'body')
  if (!bodyParams.length) return []
  return bodyParams.map((p) => getParamDisplayValue(p))
})

const previewHeader = computed<IHeaderTemplate>(() => {
  const selectedHeader = selectedTemplate.value?.content.header

  if (!selectedHeader) {
    return {
      format: FormatHeader.NONE,
      content: '',
    }
  }

  return {
    format: selectedHeader.format as FormatHeader,
    content: selectedHeader.content || '',
  }
})

const previewExampleHeader = computed(() => {
  return (selectedTemplate.value?.content as PreviewContent | undefined)?.example_header ?? null
})

const previewLimitedTimeOffer = computed(() => {
  return (
    (selectedTemplate.value?.content as PreviewContent | undefined)?.limited_time_offer ?? undefined
  )
})

const previewButtons = computed<IButtonTemplate[]>(() => {
  return ((selectedTemplate.value?.content.buttons || []) as PreviewButtonSource[]).map(
    (button) => ({
      ...button,
      type:
        button.type === TypeButton.PHONE_NUMBER
          ? TypeButton.VOICE_CALL
          : (button.type as Exclude<TypeButton, TypeButton.PHONE_NUMBER>),
      text: button.text,
      data: button.data ?? button.example ?? button.url ?? button.phone_number ?? null,
    }),
  )
})

type CarouselButtonType = ICarouselTemplate['buttonTypes'][number]

interface RawCarouselCardComponent {
  type?: string | null
  format?: string | null
  text?: string | null
  sub_type?: string | null
  parameters?: Array<{
    type?: string | null
    text?: string | null
    image?: { link?: string | null } | null
    video?: { link?: string | null } | null
  }> | null
}

interface RawCarouselCard {
  components?: RawCarouselCardComponent[] | null
}

interface RawCarouselComponent {
  type?: string | null
  cards?: RawCarouselCard[] | null
}

const normalizeButtonType = (type?: string | null): CarouselButtonType => {
  if (type === TypeButton.URL) return TypeButton.URL
  if (type === TypeButton.PHONE_NUMBER || type === TypeButton.VOICE_CALL) {
    return TypeButton.PHONE_NUMBER
  }

  return TypeButton.QUICK_REPLY
}

const normalizeCarousel = (carousel?: ICarouselTemplate | null): ICarouselTemplate | undefined => {
  if (!carousel?.cards?.length) return undefined

  const buttonTypes = carousel.buttonTypes?.length
    ? carousel.buttonTypes.map((type) => normalizeButtonType(type))
    : carousel.cards[0]?.buttons?.map((button) => normalizeButtonType(button.type)) || [
        TypeButton.QUICK_REPLY,
      ]

  return {
    mediaType: carousel.mediaType === FormatHeader.VIDEO ? FormatHeader.VIDEO : FormatHeader.IMAGE,
    buttonCount: (buttonTypes.length > 1 ? 2 : 1) as 1 | 2,
    buttonTypes,
    cards: carousel.cards.map((card) => ({
      media: card.media || card.mediaUrl || card.exampleMedia || '',
      body: card.body || card.sampleText || '',
      bodyExamples: card.bodyExamples || [],
      buttons: buttonTypes.map((type, index) => ({
        type,
        text: card.buttons?.[index]?.text || '',
        data:
          card.buttons?.[index]?.data ||
          card.buttons?.[index]?.phone_number ||
          card.buttons?.[index]?.url ||
          null,
      })),
    })),
  }
}

const buildCarouselFromPayloadCards = (
  cards?: ICarouselPayloadTemplate[] | null,
): ICarouselTemplate | undefined => {
  if (!cards?.length) return undefined

  const firstCardButtons = cards[0]?.buttons || []
  const buttonTypes: CarouselButtonType[] = firstCardButtons.length
    ? firstCardButtons.map((button) => normalizeButtonType(button.type))
    : [TypeButton.QUICK_REPLY]

  return {
    mediaType:
      cards[0]?.headerType === FormatHeader.VIDEO ? FormatHeader.VIDEO : FormatHeader.IMAGE,
    buttonCount: (buttonTypes.length > 1 ? 2 : 1) as 1 | 2,
    buttonTypes,
    cards: cards.map((card) => ({
      media:
        String(card.media_base64 ?? '').trim() ||
        String(card.exampleMedia ?? '').trim() ||
        String(card.mediaUrl ?? '').trim(),
      mediaUrl: card.mediaUrl,
      mediaId: card.mediaId,
      exampleMedia: card.exampleMedia,
      headerType: card.headerType || undefined,
      body: card.body || card.sampleText || '',
      sampleText: card.sampleText,
      // bodyExamples: card.sampleText ? [card.sampleText] : [],
      bodyExamples: [],
      buttons: buttonTypes.map((type, index) => {
        const button = card.buttons?.[index]

        return {
          type,
          text: button?.text || '',
          data:
            button?.buttonValue || button?.url || button?.suffix || button?.example?.[0] || null,
          url: button?.url || null,
          phone_number: type === TypeButton.PHONE_NUMBER ? button?.buttonValue || null : null,
        }
      }),
    })),
  }
}

const getMediaLinkFromComponent = (component?: RawCarouselCardComponent) => {
  const mediaParameter = component?.parameters?.find((parameter) =>
    ['image', 'video'].includes(String(parameter.type).toLowerCase()),
  )

  return mediaParameter?.image?.link || mediaParameter?.video?.link || ''
}

const buildCarouselFromTemplateComponents = (): ICarouselTemplate | undefined => {
  const components = selectedTemplate.value?.content.template?.components as
    | RawCarouselComponent[]
    | undefined

  const carouselComponent = components?.find(
    (component) =>
      String(component.type).toLowerCase() === 'carousel' && Array.isArray(component.cards),
  )

  if (!carouselComponent?.cards?.length) return undefined

  const firstCardComponents = carouselComponent.cards[0]?.components || []
  const buttonComponents = firstCardComponents.filter(
    (component) => String(component.type).toLowerCase() === 'button',
  )
  const buttonTypes: CarouselButtonType[] = buttonComponents.length
    ? buttonComponents.map((button) => normalizeButtonType(button.sub_type))
    : [TypeButton.QUICK_REPLY]

  const mediaType =
    firstCardComponents.find((component) => String(component.type).toLowerCase() === 'header')
      ?.format === FormatHeader.VIDEO
      ? FormatHeader.VIDEO
      : FormatHeader.IMAGE

  return {
    mediaType,
    buttonCount: (buttonTypes.length > 1 ? 2 : 1) as 1 | 2,
    buttonTypes,
    cards: carouselComponent.cards.map((card) => {
      const cardComponents = card.components || []
      const headerComponent = cardComponents.find(
        (component) => String(component.type).toLowerCase() === 'header',
      )
      const bodyComponent = cardComponents.find(
        (component) => String(component.type).toLowerCase() === 'body',
      )
      const cardButtons = cardComponents.filter(
        (component) => String(component.type).toLowerCase() === 'button',
      )

      return {
        media: getMediaLinkFromComponent(headerComponent),
        body: bodyComponent?.text || bodyComponent?.parameters?.[0]?.text || '',
        bodyExamples: bodyComponent?.parameters?.map((parameter) => parameter.text || '') || [],
        buttons: buttonTypes.map((type, index) => ({
          type,
          text: cardButtons[index]?.text || '',
          data: cardButtons[index]?.parameters?.[0]?.text || null,
        })),
      }
    }),
  }
}

const previewCarousel = computed<ICarouselTemplate | undefined>(() => {
  return (
    normalizeCarousel(selectedTemplate.value?.content.carousel) ||
    buildCarouselFromPayloadCards(selectedTemplate.value?.content.cards) ||
    buildCarouselFromTemplateComponents()
  )
})

const isCarouselTemplate = computed(() => {
  return Boolean(
    previewCarousel.value ||
      String(selectedTemplate.value?.content.header?.format ?? '').toUpperCase() === 'CAROUSEL' ||
      selectedTemplate.value?.combination?.toLowerCase().includes('carousel'),
  )
})

const buildParamLabel = (
  componentType: string,
  subType: string | null,
  paramIdx: number,
  paramType?: string,
): string => {
  const typeLabel = componentType.toLowerCase()
  if (paramType === 'image') return t('whatsapp.template_param_image', { type: typeLabel })
  if (typeLabel === 'button' && subType)
    return t('whatsapp.template_param_button', {
      subType: subType.toLowerCase(),
      index: paramIdx + 1,
    })
  return t('whatsapp.template_param_text', { type: typeLabel, index: paramIdx + 1 })
}

const getTextVariableIndexes = (content?: string | null): number[] => {
  if (!content) return []

  return [...content.matchAll(/\{\{\s*(\d+)\s*\}\}/g)]
    .map((match) => Number(match[1]))
    .filter((index, position, indexes) => index > 0 && indexes.indexOf(index) === position)
    .sort((a, b) => a - b)
}

const createTextParameter = (): TemplateSendParameter => ({
  type: 'text',
  text: '',
  image: null,
  video: null,
  document: null,
  limited_time_offer: null,
  coupon_code: null,
})

const getTemplateComponents = (template: Template): TemplateSendComponent[] => {
  const components = (template.content.template?.components || []).map((component) => ({
    ...component,
    parameters: [...(component.parameters || [])],
  }))

  const ensureTextParameters = (componentType: 'header' | 'body', content?: string | null) => {
    const variableIndexes = getTextVariableIndexes(content)
    if (!variableIndexes.length) return

    const component = components.find((item) => String(item.type).toLowerCase() === componentType)

    if (!component) {
      components.push({
        type: componentType,
        parameters: variableIndexes.map(() => createTextParameter()),
        sub_type: null,
        index: null,
        cards: null,
      })
      return
    }

    const missingParameterCount = variableIndexes.length - component.parameters.length
    if (missingParameterCount > 0) {
      component.parameters.push(
        ...Array.from({ length: missingParameterCount }, () => createTextParameter()),
      )
    }
  }

  ensureTextParameters('header', template.content.header?.content)
  ensureTextParameters('body', template.content.body)

  return components
}

const extractTemplateParameters = (template: Template | null): TemplateParam[] => {
  if (!template) return []

  const params: TemplateParam[] = []

  getTemplateComponents(template).forEach((component) => {
    if (!component.parameters?.length) return

    component.parameters.forEach((param, paramIdx) => {
      const isHeaderMediaParameter =
        component.type.toLowerCase() === 'header' &&
        ['image', 'video', 'document'].includes(String(param.type).toLowerCase())

      if (isHeaderMediaParameter && !showHeaderMediaParameters) return

      if (String(param.type).toLowerCase() === 'text' && param.text !== null) {
        const paramValue = param.text ?? ''

        params.push({
          label: paramValue || buildParamLabel(component.type, component.sub_type, paramIdx),
          placeholder: paramValue,
          value: '',
          componentType: component.type,
          componentIndex: component.index ?? null,
          parameterIndex: paramIdx,
          parameterType: 'text',
        })
      } else if (String(param.type).toLowerCase() === 'image' && param.image?.link) {
        const paramValue = param.image.link

        params.push({
          label: paramValue || buildParamLabel(component.type, null, paramIdx, 'image'),
          placeholder: paramValue,
          value: paramValue,
          componentType: component.type,
          componentIndex: component.index ?? null,
          parameterIndex: paramIdx,
          parameterType: 'image',
        })
      }
    })
  })

  return params
}

const buildUpdatedComponents = (): TemplateSendComponent[] | null => {
  if (!selectedTemplate.value) return null

  return getTemplateComponents(selectedTemplate.value).map((component) => ({
    ...component,
    parameters:
      component.parameters?.map((param, paramIdx) => {
        const userParam = templateParameters.value.find(
          (p) =>
            p.componentType === component.type &&
            p.componentIndex === (component.index ?? null) &&
            p.parameterIndex === paramIdx,
        )

        if (!userParam) return param

        if (String(param.type).toLowerCase() === 'text') {
          return { ...param, text: userParam.value }
        }
        if (String(param.type).toLowerCase() === 'image' && param.image) {
          return { ...param, image: { ...param.image, link: userParam.value } }
        }
        return param
      }) ?? [],
  }))
}

const getTemplateCategoryLabel = (template: Template) => {
  return String(template.content.category).toUpperCase() === 'MARKETING'
    ? t('whatsapp.template_type_marketing')
    : t('whatsapp.template_type_utility')
}

const getTemplateCategoryClassKey = (template: Template) => {
  return String(template.content.category).toUpperCase() === 'MARKETING' ? 'marketing' : 'utility'
}

const getCategoryBadgeClass = (template: Template) => {
  return getTemplateCategoryClassKey(template) === 'marketing'
    ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-200'
    : 'bg-sky-100 text-sky-700 dark:bg-sky-950 dark:text-sky-200'
}

const getTemplateCardClass = (template: Template) => {
  const isSelected = selectedTemplate.value?.id === template.id
  if (isSelected) {
    return '!bg-[var(--p-primary-200)]/50 dark:!bg-[var(--p-primary-600)]/40 shadow-sm hover:!bg-[var(--p-primary-400)]/20  dark:hover:!bg-[var(--p-primary-800)]/70'
  }

  return 'bg-white/40 dark:bg-[var(--p-primary-300)]/10! border-[var(--p-primary-200)] hover:!bg-[var(--p-primary-50)] dark:hover:!bg-[var(--p-primary-900)]/50'
}

const getTemplatePreview = (template: Template) => {
  const rawContent = template.content.body || template.description || ''
  const normalizedContent = rawContent
    .replace(/\{\{(\d+)\}\}/g, (_match, index: string) => `{{${index}}}`)
    .replace(/\s+/g, ' ')
    .trim()

  return normalizedContent || t('whatsapp.template_without_content')
}

const updatePreview = () => {
  emit('update:parameters', buildUpdatedComponents())
}

const selectTemplate = (template: Template) => {
  selectedTemplate.value = template
  templateParameters.value = extractTemplateParameters(template)
  emit('update:template', template)
  updatePreview()
}

watch(
  // Solo se refresca si el seleccionado viene en la pagina nueva. Que no venga
  // es lo normal al pasar de pagina: no significa que haya dejado de existir.
  () => props.templates,
  (templates) => {
    if (!selectedTemplate.value) return

    const stillAvailable = templates.find((template) => template.id === selectedTemplate.value?.id)

    if (!stillAvailable) return

    selectedTemplate.value = stillAvailable
    templateParameters.value = extractTemplateParameters(stillAvailable)
    updatePreview()
  },
  { deep: true },
)

watch(
  () => props.selectedTemplate,
  (template) => {
    if (!template) {
      selectedTemplate.value = null
      templateParameters.value = []
      return
    }

    selectedTemplate.value = template
    templateParameters.value = extractTemplateParameters(template)
  },
  { deep: true, immediate: true },
)

watch(
  () => selectedTemplate.value,
  (template) => {
    emit('update:template', template)
  },
)
</script>
